export default "__VITE_ASSET__B5J6tlaQ__"